document.addEventListener('turbolinks:load', function () {
  // meter_readings report
  $('.js-meters-select').select2({
    placeholder: 'Seleccione uno o varios medidores',
    width: '100%',
  });

  // maintenance_work_performed report
  $('#report-by-asset-1').hide();
  $('#by_asset_check_1').on('click', function () {
    $('#report-by-asset-1').toggle(this.checked);
  });
});
